import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Switch } from '@mui/material';
import { Box } from '@mui/system';
import theme from "../../theme"






export default function CustomizedSwitch(props){
  

  return(
    <Box >
    <Switch 
              checked={props.checked}
              onChange={props.onChange}
              //value={props.value}
              sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                  color: theme.palette.primary.dark,
                  '&:hover': {
                    color: theme.palette.primary.dark, 
                  },
                },
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: theme.palette.primary.dark,
                },

              }}
             
            />
    </Box>
  )
}



